<template>
  <b-card body-class="p-0" header-class="border-0">
    <!--
    <template v-slot:header>
      <h3 class="mb-0">Components</h3>
    </template>
    -->
    <template v-slot:header>
      <slot name="header">
        <h3 class="mb-0">Components</h3>
      </slot>
    </template>

    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light"
      :data="data.slice(0, itemLimit)"
      ref="data"
      @row-click="rowClicked"
    >
      <el-table-column
        type="expand"
        v-if="windowWidth >= 576 || rowNowClicked == true"
      >
        <template slot-scope="props">
          <b-card>
            <template v-slot:header>
              <!-- Subtitle -->
              <h6 class="surtitle">Overview</h6>
              <!-- Title -->
              <h5 class="h3 mb-0">Response Time</h5>

              <a
                @click="singleDayChart(props.row.id)"
                class="btn btn-sm btn-neutral"
              >
                1 day
              </a>
              <a
                @click="sevenDayChart(props.row.id)"
                class="btn btn-sm btn-neutral"
              >
                7 days
              </a>
              <a
                @click="thirtyDayChart(props.row.id)"
                class="btn btn-sm btn-neutral"
              >
                30 days
              </a>
            </template>
            <div class="chart">
              <line-chart
                @hook:mounted="renderChart(props.row)"
                :height="350"
                :chart-data="individualChartData[props.row.id]"
                :extra-options="chartOptions"
              ></line-chart>
            </div>
          </b-card>
        </template>
      </el-table-column>
      <el-table-column label="Component" min-width="100px" prop="name" sortable>
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <span class="rounded-circle mr-3">
              <b-img
                v-if="row.faviconUrl"
                class="favicon-img"
                alt="Image placeholder"
                :src="row.faviconUrl"
              ></b-img>

              <i v-else class="ni ni-app component-icon"></i>
            </span>
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">
                {{ row.name }}
              </span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column label="Status" min-width="105px" prop="status" sortable>
        <template v-slot="{ row }">
          <!-- Multiple ongoing incidents -->
          <badge
            v-if="
              row.latestIncident &&
              row.latestIncident.page_status_indicator != 'maintenance' &&
              row.latestIncident.status != 'resolved' &&
              row.latestIncident.status != 'monitoring'
            "
            class="badge-dot mr-4"
            type=""
          >
            <i class="far fa-times-circle status-icon red"></i>
            <span class="status">
              {{ row.latestIncident.page_status_description }}
            </span>
          </badge>

          <!-- Single ongoing incident -->
          <badge
            v-else-if="
              row.latestIncident &&
              row.latestIncident.page_status_indicator == 'maintenance'
            "
            class="badge-dot mr-4"
            type=""
          >
            <i class="fas fa-info status-icon orange"></i>
            <span class="status">
              {{ row.latestIncident.page_status_description }}
            </span>
          </badge>

          <!-- Latency issues - looking at Ping -->
          <badge
            v-else-if="
              row.pings.length > 0 &&
              row.pings[row.pings.length - 1].errorStatusCode === 500
            "
            class="badge-dot mr-4"
            type=""
          >
            <i class="status-icon bg-danger"></i>
            <span class="status">
              Down: error {{ row.pings[row.pings.length - 1].errorStatusCode }}
            </span>
          </badge>

          <!-- Everything is good! -->
          <badge v-else class="badge-dot mr-4" type="">
            <i class="fas fa-check-circle status-icon green"></i>
            <span class="status">Up</span>
          </badge>
        </template>
      </el-table-column>

      <el-table-column
        v-if="windowWidth >= 576"
        label="Latest Latency"
        prop="pings[0].duration"
        min-width="75px"
        sortable
      >
        <template v-slot="{ row }">
          <span class="status" v-if="row.pings[0]">
            {{ row.pings[0].duration }} ms
          </span>
          <span class="status" v-else>No data yet</span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="windowWidth >= 576"
        label="7d Avg Latency"
        prop="avgPing"
        min-width="75px"
        sortable
      >
        <template v-slot="{ row }">
          <span class="status">{{ row.avgPing }} ms</span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="windowWidth >= 576"
        label="7d Uptime"
        prop="completion"
        min-width="95px"
        sortable
      >
        <template v-slot="{ row }">
          <div class="d-flex align-items-center">
            <span class="completion mr-2">{{ row.upTime }}%</span>
            <div>
              <base-progress :type="row.statusType" :value="row.upTime" />
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column min-width="50px" v-if="ownsCurrentWebsite">
        <template v-slot="{ row }">
          <modal
            ref="notifyModal"
            :show.sync="notifyModal[row.id]"
            title="Notifications"
            id="notifyModal"
          >
            <h6 slot="header" class="modal-title">Notifications</h6>
            <monitor-notify v-bind:component-info="row"></monitor-notify>

            <template v-slot:footer>
              <base-button @click="hideModal(row.id)" type="secondary">
                Cancel
              </base-button>
              <base-button
                @click="editComponentClosed(row)"
                icon
                type="primary"
              >
                Submit
              </base-button>
            </template>
          </modal>

          <modal
            ref="mymodal"
            :show.sync="modal[row.id]"
            title="Edit"
            id="modal1"
          >
            <h6 slot="header" class="modal-title">Edit Component</h6>
            <b-form-group>
              <b-input-group prepend="Name">
                <b-form-input
                  v-model="editComponentName"
                  :value="row.name"
                  placeholder="BoltScale"
                ></b-form-input>
              </b-input-group>
              <b-input-group prepend="URL">
                <b-form-input
                  v-model="editComponentUrl"
                  :type="'url'"
                  :value="row.endpoint"
                  placeholder="https://api.boltscale.io"
                ></b-form-input>
              </b-input-group>
            </b-form-group>

            <template v-slot:footer>
              <base-button @click="hideModal(row.id)" type="secondary">
                Cancel
              </base-button>
              <base-button
                @click="editComponentClosed(row)"
                icon
                type="primary"
              >
                Submit
              </base-button>
            </template>
          </modal>

          <el-dropdown class="dropdown" min-width="25px">
            <span class="btn btn-sm btn-icon-only text-light">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <b-dropdown-item v-if="!thirdparty" @click="openModal(row)">
                Edit
              </b-dropdown-item>
              <b-dropdown-item @click="openNotificationsModal(row)">
                Notifications
              </b-dropdown-item>
              <b-dropdown-item @click="removeComponent(row)">
                Remove
              </b-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!--
    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination v-model="currentPage" :per-page="4" :total="50"></base-pagination>
  </b-card-footer>
  --></b-card>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import LineChart from "@/components/Charts/LineChart";
import MonitorNotify from "@/components/MonitorNotify";

export default {
  name: "component-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    LineChart,
    MonitorNotify
  },
  props: ["data", "itemLimit", "ownsCurrentWebsite", "thirdparty"],
  data() {
    return {
      rowNowClicked: false,
      windowWidth: window.innerWidth,
      editComponentName: "",
      editComponentUrl: "",
      currentPage: 1,
      modal: {},
      notifyModal: {},
      chartOptions: {
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                tooltipFormat: "MMM D, h:mm a"
              }
            }
          ]
        }
      },
      individualChartData: {},
      allChartDataDays: {},
      chartData: {
        labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        datasets: [
          {
            label: "Performance",
            data: [0, 20, 10, 30, 15, 40, 20, 60, 60]
          }
        ]
      }
    };
  },
  methods: {
    beforeDestroy() {
      window.removeEventListener("resize", this.handleResize);
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    openModal(row) {
      console.log(row);
      this.$set(this.modal, row.id, true);
      console.log(this.modal);
    },
    openNotificationsModal(row) {
      console.log(row);
      this.$set(this.notifyModal, row.id, true);
      console.log(this.notifyModal);
    },
    removeComponent(row) {
      console.log("Removing component");
      this.$http
        .post("/components/delete", {
          id: row.id
        })
        .then((resp) => {
          console.log("Component was deleted.");
          this.$emit("refresh");
          /*
          this.data.forEach((data, i) => {
            if (data.id == row.id) {
              this.$delete(this.data, i);
            }
          });*/
        });
    },
    hideModal(rowId) {
      this.$refs.mymodal.closeModal();
    },
    editComponentClosed(row) {
      console.log("Editing component closed!");
      const editedComponentId = row.id;
      const name = this.editedComponentName;
      const url = this.editedComponentUrl;

      this.$http
        .post("/components/update", {
          id: editedComponentId,
          name: this.editComponentName,
          url: this.editComponentUrl
        })
        .then((resp) => {
          this.$emit("refresh");
          console.log(resp);
          /*
          this.data.forEach((data, i) => {
            if (data.id == editedComponentId) {
              data.name = this.editComponentName;
              data.url = this.editComponentUrl;
              this.$set(this.data, i, resp.data.component);
            }
          });*/
        });
      console.log("Edit component closed");
      console.log(row);
      this.$refs.mymodal.closeModal();
    },
    rowClicked(row) {
      this.rowNowClicked = true;
      this.$nextTick(function () {
        this.$refs.data.toggleRowExpansion(row);
      });
    },
    singleDayChart(id) {
      const data = this.allChartDataDays[id].singleDay;
      this.drawChart(id, data);
    },
    sevenDayChart(id) {
      const data = this.allChartDataDays[id].sevenDay;

      this.drawChart(id, data);
    },
    thirtyDayChart(id) {
      const data = this.allChartDataDays[id].thirtyDay;

      this.drawChart(id, data);
    },
    drawChart(id, pingObj) {
      const chartData = {
        labels: pingObj.labels,
        datasets: [
          {
            label: "Average Latency",
            data: pingObj.avg,
            borderColor: "rgba(0,0,0,0.5)",
            backgroundColor: "rgba(246, 249, 252, 0.8)",
            borderWidth: 1
          },
          {
            label: "Max Latency",
            data: pingObj.max,
            //backgroundColor: "rgba(246, 249, 252, 0.8)",
            //backgroundColor: "rgba(94, 113, 228, 0.1)",
            borderColor: "#fb6340",
            backgroundColor: "rgba(251, 99, 64, 0.1)",
            borderWidth: 1
          },
          {
            label: "Min Latency",
            data: pingObj.min,
            borderColor: "#2dce89",
            backgroundColor: "rgba(45, 206, 137, 0.8)",
            borderWidth: 1
          }
        ]
      };
      this.$set(this.individualChartData, id, chartData);
    },
    renderChart(ev) {
      console.log("Getting chart data...");
      const chartData = this.$http
        .get("/monitor/pings/" + ev.id)
        .then((resp) => {
          console.log("Got chart data");
          console.log(resp.data.pings);
          this.$set(this.allChartDataDays, ev.id, resp.data.pings);
          this.singleDayChart(ev.id);
        });
    }
  },
  mounted() {
    const self = this;

    window.addEventListener("resize", this.handleResize);
    console.log(this.thirdparty);
    console.log("Holy fuck table mounted");
    console.log("Table mounted!");
    console.log(this.data);

    for (const component of this.data) {
      this.$set(this.individualChartData, component.id, {});
    }

    console.log("AGAIN INDIVIDUA CHART DATA");
    console.log(this.individualChartData);
  },
  watch: {
    data: function (val) {
      for (const component of val) {
        this.$set(this.individualChartData, component.id, {});
      }
    }
  }
};
</script>
<style>
/*
.avatar {
  height: auto;
  width: auto;
}
*/

.favicon-img {
  width: 16px;
}

.component-icon {
  font-size: 16px;
  vertical-align: middle;
}

.status-icon {
  padding-right: 23px;
  font-size: 20px !important;
  vertical-align: text-top !important;
}

.status-icon.green {
  color: #2bce89;
}

.status-icon.red {
  color: #f5365c;
}

.status-icon.orange {
  color: #fb6340;
}

.el-table__expand-column .cell {
  overflow: visible;
}
</style>
